import { render, staticRenderFns } from "./PageRankGoodsIncome.vue?vue&type=template&id=1811bee8&scoped=true"
import script from "./PageRankGoodsIncome.vue?vue&type=script&lang=js"
export * from "./PageRankGoodsIncome.vue?vue&type=script&lang=js"
import style0 from "./PageRankGoodsIncome.vue?vue&type=style&index=0&id=1811bee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811bee8",
  null
  
)

export default component.exports